import InsightsDashboardSkeleton from './InsightsDashboardSkeleton';
import useFirstLoadSplash from '../../hooks/ui/useFirstLoadSplash';

/**
 * First-load shell for role home pages (Admin, Billing, Worker, Supervisor).
 * Delegates to {@link InsightsDashboardSkeleton} for layout-faithful variants.
 *
 * Mounts exactly while a role-home is `loading`, so it doubles as the wire-in
 * point for {@link useFirstLoadSplash}: on the first boot the singleton splash
 * holds over this skeleton (no skeleton flash) and auto-clears when data-ready
 * unmounts it. Platform dashboard uses the same path via {@link PlatformDashboardTab}.
 *
 * @param {'admin'|'billing'|'worker'|'supervisor'|'platform'|'generic'} [variant]
 *   `generic` = flat KPI + hero + list (Job detail, legacy).
 * @param {boolean} [chunkFallback] AppShell's chunk-load fallback: holds the
 *   splash without spending the first-load claim (the home's data load keeps it).
 */
export default function DashboardLoadSkeleton({ chunkFallback = false, ...props }) {
  // `chunkFallback` (AppShell's Suspense fallback while a role home's JS
  // loads): hold the splash, but leave the first-load claim to the home.
  useFirstLoadSplash(props.variant, true, { claim: !chunkFallback });
  return <InsightsDashboardSkeleton {...props} />;
}
